import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get } from '../../modules/logistics/terminal';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state, ownProps) => {
	const terminalId = (ownProps.terminalId)
		? ownProps.terminalId
		: _.get(ownProps, ['match', 'params', 'terminalId']);
	const terminal = _.get(state.maps, ['terminal', terminalId]);

	return {
		terminal
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getTerminal : get,
	addTerminal : add,
	updateTerminal : update,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
